import { useMemo, useState } from "react";
import { Grid } from "@mui/material";
import { IReportWebdatarocks } from "@vmosolutions/oc-interfaces";

// Import WDR Pivot table components.
import { WDRPivotTable } from "src/components/Reporting/WebDataRocks/WDRPivotTable";

interface IReportingWindowProps {
  //id: string;
  //path: string[];
  windowProps: {
    webdatarocksReport: IReportWebdatarocks;
    URLparams?: string;
  };
}

export const ReportingWindow = (props: IReportingWindowProps): JSX.Element => {
  const { windowProps } = props;
  const { webdatarocksReport, URLparams } = windowProps;

  // Set windowProps to component state so that switching mosaic tabs doesn't reload report.
  const [reportData] = useState<any>({ webdatarocksReport, URLparams });

  // Attach URLParams to report and pass to component for display.
  // NOTE: Doing this here, allows for easier change detection is user wanted to "refresh params"
  const report = useMemo(() => {
    if (!reportData) {
      return null;
    }
    const { webdatarocksReport, URLparams } = reportData;

    const reportFileName = webdatarocksReport?.data?.dataSource?.filename;
    if (reportFileName && URLparams) {
      // Retrieve current report params and append any passed in from window props.
      const [file, params] = reportFileName.split("?");
      const newParams =
        params && URLparams
          ? "?" + params + "&" + URLparams
          : params && !URLparams
            ? "?" + params
            : !params && URLparams
              ? "?" + URLparams
              : "";
      const updatedfileName = file + newParams;
      const updatedDataSource = { ...webdatarocksReport.data.dataSource, filename: updatedfileName };
      const updatedData = { ...webdatarocksReport.data, dataSource: updatedDataSource };
      return { ...webdatarocksReport, data: updatedData };
    } else {
      return { ...webdatarocksReport };
    }
  }, [reportData]);

  return (
    <Grid
      item
      style={{
        height: "100%",
        width: "100%",
        minWidth: 540 /* min-width is to ensure report menu buttons don't overlap - CC */,
      }}
    >
      {<WDRPivotTable report={report} />}
    </Grid>
  );
};
